<div class="avatar" (click)="onClick()" [ngClass]="{'background': withBg}">
  <img src="{{ src }}" alt="{{ alt }}" [attr.width]="size" [attr.height]="size" loading="lazy" />
  @if (overloaded) {
    <aa-action-circle class="white-on-yellow duotone" [faIcon]="'fal ' + icon">
    </aa-action-circle>
  }
</div>
